import React, { useState, useRef, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import * as Yup from "yup";
import CustomInput from "../../../Custom/CustomInput";
import { Field, FormikProvider, useFormik } from "formik";
import { Form } from "reactstrap";
import { Row, Col, Modal } from "react-bootstrap";
import PaginationButtons from "../../../Custom/Pagination";
import { post } from "../../../Helper/api_helper";
import swal from "sweetalert";
import { t } from "i18next";
import { Spin } from "antd";
import {
  POST_GetRadiologyReportList,
  POST_RadiologyReportDelete,
  POST_RadiologyReportSetActiveInActive,
  POST_GetRadiologyReportDetailByID,
  POST_RadiologyReportUpdate,
  POST_RadiologyReportCreate,
} from "../../../Helper/url_helper";
const RadiologyReportList = () => {
  const [radiologyReportModal, setRadiologyReportModal] = useState(false);
  const [recordCount, setRecordCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10);
  const [radiologyList, setRadiologyList] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  var objLogin = JSON.parse(localStorage.getItem("userDetails"));

  const handleOnChangeSearch = (e) => {
    setSearch(e.target.value);
  };

  const validationSchemaRadiologyReport = Yup.object().shape({
    RadiologyReportName: Yup.string().required(
      "Radiology Report Name is required field"
    ),
  });

  const formikRadiologyReport = useFormik({
    validationSchema: validationSchemaRadiologyReport,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitRadiologyReport(values, formikHelpers),
    initialValues: {
      RadiologyReportID: "",
      RadiologyReportName: "",
      Status: true,
    },
    validateOnBlur: false,
  });
  const {
    setValues,
    setFieldValue,
    values: { RadiologyReportID },
  } = formikRadiologyReport;

  useEffect(() => {
    getData();
  }, [search]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);
    let response = await post(POST_GetRadiologyReportList, {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: search,
      Sorting: "",
      LoginID: objLogin.LoginIDEncrypt,
    });
    setIsLoading(false);
    setRecordCount(response.TotalRecordCount);
    setRadiologyList(response.RadiologyReportList);
    //setCurrentPage(page);
    setCurrentSizePerPage(sizePerPage);
    if (page > 1 && response?.RadiologyReportList?.length === 0) {
      setCurrentPage(page - 1);
      getData(page - 1);
    } else {
      setCurrentPage(page);
    }
  };

  const delete_RadiologyReport = (rID) => {
    swal({
      title: "Are you sure you want to delete the radiology report?",
      text: "You won't be able to revert this!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((confirmDelete) => {
      if (confirmDelete) {
        delete_RadiologyReportConfirm(rID);
      }
    });
  };

  const delete_RadiologyReportConfirm = async (rID) => {
    setIsLoading(true);
    let response = await post(POST_RadiologyReportDelete, {
      EncryptedRadiologyReportID: rID,
      EncryptedModifiedBy: objLogin.LoginIDEncrypt,
    });
    if (response.IsSuccess) {
      swal({
        title: "Deleted",
        text: "Record has been deleted.",
        icon: "success",
        button: "OK",
      });
      getData(currentPage, currentSizePerPage);
    } else {
      swal("Error!", t(response.MessageCode), "error");
    }
    setIsLoading(false);
  };

  const ActiveInactive_RadiologyReport = async (rID, rStatus) => {
    swal({
      title: `Are you sure you want to ${
        rStatus ? "inactive" : "active"
      } the radiology report?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((confirmStatus) => {
      if (confirmStatus) {
        ActiveInactive_RadiologyReportConfirm(rID, rStatus);
      }
    });
  };

  const ActiveInactive_RadiologyReportConfirm = async (rID, rStatus) => {
    setIsLoading(true);
    let response = await post(POST_RadiologyReportSetActiveInActive, {
      EncryptedRadiologyReportID: rID,
      IsActive: !rStatus,
      EncryptedModifiedBy: objLogin.LoginIDEncrypt,
    });
    if (response.IsSuccess) {
      swal({
        title: rStatus ? "Inactivated" : "Activated",
        text: rStatus
          ? "Record has been Inactivated."
          : "Record has been Activated.",
        icon: "success",
        button: "OK",
      });
      getData(currentPage, currentSizePerPage);
    } else {
      swal("Error!", t(response.MessageCode), "error");
    }
    setIsLoading(false);
  };

  const get_RadiologyReport = async (rID) => {
    setIsLoading(true);
    let response = await post(POST_GetRadiologyReportDetailByID, {
      RadiologyReportIDEncrypt: rID,
    });
    if (response.IsSuccess) {
      setValues({
        RadiologyReportID: response.RadiologyReportIDEncrypt,
        RadiologyReportName: response.RadiologyReportName,
        Status: response.IsActive,
      });
      setRadiologyReportModal(true);
    } else {
      swal("Error!", t(response.MessageCode), "error");
    }
    setIsLoading(false);
  };

  const handleValidSubmitRadiologyReport = (values, { setSubmitting }) => {
    setIsLoading(true);

    const data = {
      RadiologyReportIDEncrypt: values.RadiologyReportID,
      RadiologyReportName: values.RadiologyReportName.trim(),
      IsActive: values.Status,
      ModifiedByEncrypt: objLogin.LoginIDEncrypt,
      CreatedByEncrypt: objLogin.LoginIDEncrypt,
    };
    post(
      RadiologyReportID
        ? POST_RadiologyReportUpdate
        : POST_RadiologyReportCreate,
      data
    )
      .then((response) => {
        if (response.IsSuccess) {
          swal({
            title: "Success",
            text: t(response.MessageCode),
            icon: "success",
            button: "OK",
          });
          setRadiologyReportModal(false);
          getData(1, currentSizePerPage);
        } else {
          swal({
            title: "Error",
            text: t(response.MessageCode),
            icon: "error",
            button: "OK",
          });
          //setRadiologyReportModal(false);
          //formikRadiologyReport.resetForm();
        }
      })
      .catch((error) => {
        console.log(error);
      });
    setIsLoading(false);
  };

  function add_RadiologyReport() {
    formikRadiologyReport.resetForm();
    setValues({
      RadiologyReportID: "",
      RadiologyReportName: "",
      Status: true,
    });
    setRadiologyReportModal(!radiologyReportModal);
  }

  return (
    <>
      <Fragment>
        <Spin size="large" spinning={isLoading} tip={"Loading..."}>
          <PageTitle motherMenu="Master" activeMenu="Radiology Reports" />

          <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
            <div className="mr-auto d-none d-lg-block">
              <div
                onClick={() => add_RadiologyReport()}
                className="btn-xs btn btn-primary btn-rounded"
              >
                + Add Radiology Reports
              </div>
            </div>
            <div className="input-group search-area ml-auto d-inline-flex mr-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search here"
                value={search}
                onChange={handleOnChangeSearch}
              />
              <div className="input-group-append">
                <button type="button" className="input-group-text">
                  <i className="flaticon-381-search-2" />
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="table-responsive">
                <div id="radio_list" className="dataTables_wrapper no-footer">
                  <table
                    id="example5"
                    className="table table-striped patient-list mb-4 dataTablesCard fs-14 dataTable no-footer"
                    role="grid"
                    aria-describedby="example5_info"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Radiology Report Name: activate to sort column ascending"
                          style={{ width: "90%" }}
                        >
                          Radiology Report Name
                        </th>

                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Actions: activate to sort column ascending"
                          style={{ width: "10%" }}
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    {recordCount > 0 ? (
                      <tbody>
                        {radiologyList?.map((element, i) => (
                          <tr role="row" className="odd">
                            <td key={i}>{element.RadiologyReportName}</td>
                            <td>
                              <div className="d-flex">
                                <div
                                  className="btn btn-light shadow btn-xs sharp mr-1"
                                  title="Edit"
                                  onClick={() => {
                                    get_RadiologyReport(
                                      element.RadiologyReportIDEncrypt
                                    );
                                  }}
                                >
                                  <i className="fa fa-pencil"></i>
                                </div>
                                <Link
                                  to="#"
                                  className="btn btn-light shadow btn-xs sharp mr-1 rounded-circle"
                                  title={
                                    element.IsActive ? "Active" : "Inactive"
                                  }
                                  onClick={() => {
                                    ActiveInactive_RadiologyReport(
                                      element.RadiologyReportIDEncrypt,
                                      element.IsActive
                                    );
                                  }}
                                >
                                  <i
                                    className="fa fa-circle mt-1"
                                    style={{
                                      color: element.IsActive ? "green" : "red",
                                    }}
                                  ></i>
                                </Link>
                                <Link
                                  to="#"
                                  className="btn btn-light shadow btn-xs sharp"
                                  title="Delete"
                                  onClick={() => {
                                    delete_RadiologyReport(
                                      element.RadiologyReportIDEncrypt
                                    );
                                  }}
                                >
                                  <i
                                    className="fa fa-trash"
                                    style={{ color: "red" }}
                                  ></i>
                                </Link>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <div className="mt-3 ml-3">{"No Record Found"}</div>
                    )}
                  </table>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <div
                      className="dataTables_info"
                      id="example5_info"
                      role="status"
                      aria-live="polite"
                    >
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <div className="paging_simple_numbers d-flex  justify-content-center align-items-center">
                      <PaginationButtons
                        totalPages={recordCount / currentSizePerPage}
                        currentPage={currentPage}
                        getData={getData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Modal
            className="modal fade"
            show={radiologyReportModal}
            onHide={setRadiologyReportModal}
          >
            <div className="">
              <div className="">
                <FormikProvider value={formikRadiologyReport}>
                  <Form onSubmit={formikRadiologyReport.handleSubmit}>
                    <div className="modal-header">
                      <h4 className="modal-title fs-20">Radiology Report</h4>
                      <button
                        type="button"
                        className="btn close"
                        onClick={() => setRadiologyReportModal(false)}
                      >
                        <span>×</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <i className="flaticon-cancel-12 close"></i>
                      <div className="add-contact-box">
                        <div className="add-contact-content">
                          <Row>
                            <Col lg={12}>
                              <Field
                                type="text"
                                label={"Radiology Report Name"}
                                name="RadiologyReportName"
                                placeholder={"Enter Radiology Report Name"}
                                component={CustomInput}
                                // onChange={(e) => {
                                //   setFieldValue(
                                //     "RadiologyReportName",
                                //     e.target.value.replace(
                                //       /[^A-Za-z 0-9 - + () ]/g,
                                //       ""
                                //     )
                                //   );
                                // }}
                                required
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="submit" className="btn btn-primary">
                        Save
                      </button>
                      <button
                        type="button"
                        onClick={() => setRadiologyReportModal(false)}
                        className="btn btn-light"
                      >
                        {" "}
                        <i className="flaticon-delete-1"></i> Cancel
                      </button>
                    </div>
                  </Form>
                </FormikProvider>
              </div>
            </div>
          </Modal>
        </Spin>
      </Fragment>
    </>
  );
};

export default RadiologyReportList;
